var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRandomLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3635 0.636353H0.63623V9.66457H10.793L14.7428 14.1787L13.05 15.8715L9.66444 11.9216H0.63623V22.0784H9.66444L20.9497 8.53604H27.7209V6.27899L32.235 9.66457L27.7209 13.0501V10.7931H22.0782L10.793 24.3354H0.63623V33.3636H33.3635V0.636353ZM16.4356 19.8213L18.1284 18.1285L22.0782 23.2069H27.7209V20.9498L32.235 24.3354L27.7209 27.721V25.4639H20.9497L16.4356 19.8213Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomLayer);
export default __webpack_public_path__ + "static/media/RandomLayer.565bf18ffbfdafd18cdada44b79c944a.svg";
export { ForwardRef as ReactComponent };